<template>
	<!-- Need to iterate data for the Details v-for="item in content" class="left-nav-content-full-right resource-detail" :key="item.id" for the article content -->
	<article class="left-nav-content-full-right resource-detail">
		<!-- We to pass data on the detail view {{ item.title }} for the correct title -->
		<h1>{{ resourceDetails.name }}</h1>
		<p>{{ resourceDetails.summary }}</p>
		<div class="detail-wrapper">
			<!-- We to compare the pass data on the detail view item.media_type for our v-if statement to work -->
			<section
				data-category="Quick Talks"
				v-if="['Video', 'Walkme', 'DOC'].includes(resourceDetails.resourceType)"
				class="asset-wrapper"
			>
				<video
					:id="`resources-video-${resourceDetails.marketingResourceId}`"
					class="resources-video"
					:poster="resourceDetails.previewUri"
				>
					<!-- We to pass data on the detail view item.media for the media link -->
					<source :src="[resourceDetails.media.uri]" type="video/mp4" />
					<p>
						Sorry, your browser doesn't support HTML5 video. here is a
						<a :href="[resourceDetails.media.uri]">link to the video</a>
						instead.
					</p>
				</video>
				<button
					id="play-button"
					class="item category"
					:aria-label="`view ${resourceDetails.name} ${resourceDetails.resourceType}`"
					@click="playVideo"
				>
					<font-awesome-icon
						v-if="resourceDetails.resourceType === 'Walkme'"
						:icon="['fas', 'walking']"
					/>
					<font-awesome-icon v-else :icon="['fas', 'play']" />
				</button>
			</section>
			<section
				data-category="Job Aids"
				v-if="['PDF', 'PPT', 'DOC'].includes(resourceDetails.resourceType)"
				class="asset-wrapper"
			>
				<figure
					:style="`background: url('${resourceDetails.previewUri}');`"
				></figure>
				<a
					class="b360-btn--primary download"
					:aria-label="`Download ${resourceDetails.name} ${resourceDetails.resourceType}`"
					download
					:href="[resourceDetails.media.uri]"
				>
					Download
				</a>
			</section>
		</div>
	</article>
</template>

<script>
import {
	faPlay as fasPlay,
	faWalking as fasWalking,
} from '@fortawesome/pro-solid-svg-icons/';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(fasPlay, fasWalking);

export default {
	name: 'ResourceDetails',
	components: {},
	props: {
		resourceDetails: Object,
	},
	methods: {
		playVideo() {
			document.querySelector('.resources-video').play();
			document.getElementById('play-button').remove();
			document.querySelector('.resources-video').setAttribute('controls', true);
		},
	},
};
</script>

<style lang="scss" scoped>
.resource-detail {
	border-bottom: 1px solid $border-color-light;
	@include rem(padding-bottom, 40px);
	@include sm {
		@include rem(padding-right, 15px);
	}
	h1 {
		margin-bottom: 0.2rem;
	}
	p {
		margin-top: 0;
	}
	.detail-wrapper {
		display: flex;
		flex-direction: row;
		align-items: flex-start;

		@include sm {
			flex-wrap: wrap;
		}

		.asset-wrapper {
			position: relative;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 1000px;

			@include lg {
				margin-right: 30px;
				flex-basis: 70%;
			}

			video {
				width: 100%;
				height: 100%;
				border-radius: $b360-border-radius-base;
			}

			&[data-category='Job Aids'] {
				width: 100%;
				height: 380px;
				@include phablet {
					max-width: 100%;
					margin-right: unset;
				}

				@include tablet {
					max-width: 267px;
					margin-right: 30px;
				}

				figure {
					width: 100%;
					height: 100%;
					margin: unset;
					border-radius: $b360-border-radius-base;
					background-position: center;
				}

				a.download {
					position: absolute;
					z-index: 1;
					display: inline-flex;
					justify-content: center;
					bottom: 15px;
					width: calc(100% - 50px);
					text-decoration: none;
					height: unset;

					&:hover,
					&:focus,
					&:active {
						text-decoration: none;
						color: $white;
					}
				}
			}

			button:not([data-category='Job Aids']) {
				position: absolute;
				z-index: 1;
				width: 68px;
				height: 68px;
				background-color: $brand-blue;
				color: $white;
				border: 5px solid $white;
				border-radius: $b360-border-radius-circle;
				@include rem(font-size, 30px);
				box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.12);
				display: inline-flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				svg {
					transform: translateX(2.5px);
				}
			}
		}

		.blurb-wrapper {
			padding-right: 30px;
			display: flex;
			flex-direction: column;
			flex-basis: 32%;
			flex-grow: 1;
			transition: all 0.5s ease-in-out;
			h2 {
				line-height: 1;
				@include lg {
					margin-top: 0;
				}

				&.tag {
					margin: 0 0 4px 0;
				}
			}

			.tag-wrapper {
				.tag {
					@include rem(font-size, 14px);
					padding: 10px 12px;
					line-height: 0.875rem;
					margin-right: 10px;
					margin-top: 10px;
				}
			}
		}
	}
}
</style>
